import type { IGenreMinimal } from "../../../../types/models/genre.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
    genres: Array<IGenreMinimal>;
}

export function useGetSocialGenreAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/socials-genres",
  });
}
